import {formatError} from "vue-loader/dist/formatError";

const isEmail = (val) => {
    const regex = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
    return regex.test(val)
}

const isCheck = (val, input) => input.checked

const isPhone = (val) => {
    const regex = /[()]|-|\+/gi;
    const phoneVal = val.replaceAll(regex, "");
    const regPhone = /^\+?[0-9_. -()]+$/;

    return regPhone.test(phoneVal) && phoneVal.length >= 9 ? true : false
}

const required = (val) => val.toString().length > 0 ? true : false

const isIdentical = (val_1, val_2) => val_1 === val_2 ? true : false

const fileRules = (val, params = {}) => {
    let status = true

    if(params.required) {
        if(!val) {
            status = false
        }
    }

    if(val && val.length > 0) {

        if(params.allowedExt) {
            const ext = val[0].name.split('.')[val[0].name.split('.').length - 1]
            if(!params.allowedExt.includes(ext)) {
                status = false
            }
        }

        if(params.maxSize) {
            const maxSize = (params.maxSize * 1024) * 1024
            if(val[0].size > maxSize) {
                status = false
            }
        }
    }

    return status
}

const TestText = (field) => {
    let r = {valid:true,value:[{name:field.name,value:field.value}]};
    if (field.req) {
        if (field.value?.trim() === "" || !field.value) {
            r.valid = false;
        }
    }
    if(field.maxLength) {
        if(field.value.length>field.maxLength) {
            r.valid = false;
        }
    }
    if(field.minLength) {
        if(field.value.length<field.minLength) {
            r.valid = false;
        }
    }

    return r;
}
const TestFile = (field) => {
    let r = {valid:true,value:[]};
    let kol = 0;
    let sizeSumm = 0;
    if(field.multiple) {
        for(let index in field.value) {
            if(typeof field.value[index]=="object") {
                sizeSumm+=field.value[index][0].size;
                kol++;
                r.value.push({name:field.name,value:field.value[index][0]});
            }
        }
    } else {
        if(field.value[0]!=undefined) {
            sizeSumm+=field.value[0].size;
            kol++;
            r.value.push({name:field.name,value:field.value[0]});
        }
    }
    if(r.valid) {
        if(field.maxCountFiles) {
            if(kol>field.maxCountFiles) {
                r.valid = false;
            }
        }
        if(field.maxSumSize) {
            sizeSumm/=1024;
            sizeSumm/=1024;
            if(field.maxSumSize<sizeSumm) {
                r.valid = false;
            }
        }
    }
    return r;
}
const TestLevel = (field) => {
    let r = {valid:true,value:[{name:field.name,value:field.value}]};
    if (field.req) {
        if (!field.value) {
            r.valid = false;
        }
    }
    return r;
}
const TestCheckbox = (field) => {
    let v = true;
    if(!field.value) {
        v = false;
    }
    let r = {valid:true,value:[{name:field.name,value:v}]};
    if (field.req) {
        if (!field.value) {
            r.valid = false;
        }
    }
    return r;
}
const TestDate = (field) => {
    let r = {valid:true,value:[{name:field.name,value:field.value}]};
    if (field.req) {
        if (field.value?.trim() === "" || !field.value) {
            r.valid = false;
        }
    }
    return r;
}
const TestBonuses = (field) => {
    let r = {valid:true,value:[]};
    for(let index in field.value) {
        if ( typeof field.value[index]=="object") {
           r.value.push({name:field.name,value:field.value[index].title});
        }
    }
    return r;
}
const TestSelect = (field) => {
    let r = {valid:true,value:[]};
    let multy = field.multiple?true:false;
    if (field.req) {
        if(multy) {
            console.log(field);
        }
        else {
            if (field.value?.trim() === "" || !field.value) {
                r.valid = false;
            }
        }
    }

    if(multy) {
        alert("//TODO Доделать фалидацию мультиселект");
        console.log(field);
        //r.value.push({name:field.name,value:field.value});
    }
    else {
        r.value.push({name:field.name,value:field.value});
    }
    return r;
}

const validateFormItem = (item) => {
    let r = {valid:true};
    switch (item.type) {
        case "text": case "textarea" :case "hidden" :
           r =  TestText(item);
        break;
        case "select":
           r =  TestSelect(item);
        break;
        case "date":
           r =  TestDate(item);
        break;
        case "bonuses":
            r =  TestBonuses(item);
        break;
        case "file":
            r =  TestFile(item);
        break;
        case "level":
           r =  TestLevel(item);
        break;
        case "checkbox":
           r =  TestCheckbox(item);
        break;
        default:
            console.log(item)
        break;
    }

return r;
}

export {
    required,
    isEmail,
    isCheck,
    isPhone,
    isIdentical,
    fileRules,
    validateFormItem
}